function UploadIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.12"
        d="M16.0001 29.3332C23.3639 29.3332 29.3334 23.3636 29.3334 15.9998C29.3334 8.63604 23.3639 2.6665 16.0001 2.6665C8.63628 2.6665 2.66675 8.63604 2.66675 15.9998C2.66675 23.3636 8.63628 29.3332 16.0001 29.3332Z"
        fill="currentColor"
      />
      <path
        d="M21.3334 15.9998L16.0001 10.6665M16.0001 10.6665L10.6667 15.9998M16.0001 10.6665V22.9332C16.0001 24.7874 16.0001 25.7146 16.7341 26.7526C17.2218 27.4424 18.626 28.2936 19.463 28.407C20.7229 28.5777 21.2013 28.3281 22.1582 27.829C26.4223 25.6046 29.3334 21.1422 29.3334 15.9998C29.3334 8.63604 23.3639 2.6665 16.0001 2.6665C8.63628 2.6665 2.66675 8.63604 2.66675 15.9998C2.66675 20.9351 5.34807 25.244 9.33342 27.5494"
        stroke="currentColor"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UploadIcon;
